const initMobileMenu = () => {
  const menuBtn = document.querySelector(".mainmenumob-js");
  const tierOneToggles = document.querySelectorAll(".first-tier-toggle");
  const container = document.querySelector(".mobile-nav");
  const panelOne = document.querySelector(".tier-one-panel");
  const panelTwo = document.querySelector(".tier-two-panel");
  const ttIndicator = panelTwo.querySelector(
    ".tier-two-panel__indicator svg path"
  );
  const ttHeading = document.querySelector(".tier-two-panel__current-menu");
  const overlay = document.querySelector(".mobile-nav-overlay");
  const indicators = document.querySelectorAll(".mobile-nav__panel-indicator");

  const controls = document.querySelector(".mobile-nav-controls");
  const viewLink = controls.querySelector(
    ".tier-two-panel__current-menu-collection"
  );

  const menuOpen = () => {
    if (container.classList.contains("visible")) {
      return;
    } else {
      overlay.classList.add("activated");
      document.body.classList.add("body-lock");
      container.style.display = "block";
      setTimeout(() => {
        container.classList.add("visible");
      }, 50);
    }
  };

  const menuClose = () => {
    container.classList.remove("visible");
    document.body.classList.remove("body-lock");

    setTimeout(() => {
      container.style.display = "none";
      resetPanels();
    }, 250);
    overlay.classList.remove("activated");
    tierOneToggles.forEach((toggle, i) => {
      if (i == 0) {
        !toggle.parentElement.classList.contains("active")
          ? toggle.parentElement.classList.add("active")
          : null;
      } else {
        toggle.parentElement.classList.remove("active");
      }
    });
  };

  const resetPanels = () => {
    if (panelTwo.classList.contains("show")) {
      panelTwo.classList.remove("show");
      setTimeout(() => {
        panelTwo.removeAttribute("style");
      }, 500);
      setTimeout(() => {
        panelOne.removeAttribute("style");
      }, 50);
      setTimeout(() => {
        panelOne.classList.add("show");
      }, 100);
      indicators[1].removeAttribute("style");
      document
        .querySelectorAll(".mobile-nav__secondary.first-tier-parent")
        .forEach((li, liX) => {
          let h = $(li.outerHeight(true));
          li.classList.includes("active")
            ? (indicators[0].style.transform = `translateY(${h * liX}px)`)
            : null;
        });
    } else {
      indicators.forEach((indicator) => indicator.removeAttribute("style"));
    }
    deactivateSubmenus();
    controls
      .querySelector(".tier-two-panel__back-button")
      .removeEventListener("click", resetPanels);
    controls.classList.remove("in-menu");
  };

  const switchPanels = () => {
    panelOne.classList.remove("show");
    setTimeout(() => {
      panelOne.style.display = "none";
    }, 50);
    panelTwo.removeAttribute("style");
    setTimeout(() => {
      panelTwo.classList.add("show");
    }, 50);

    controls
      .querySelector(".tier-two-panel__back-button")
      .addEventListener("click", resetPanels);

    controls.classList.add("in-menu");
    const t = panelTwo.querySelectorAll(".featured");
    handlePrimaryMenuToggle(t[0].querySelector(".first-tier-toggle"));
  };

  const deactivateSubmenus = () => {
    const submenus = document.querySelectorAll(".second-tier");
    submenus.forEach((submenu) => {
      submenu.classList.remove("active", "featured");
    });
    ttIndicator.parentElement.parentElement.removeAttribute("style");
    viewLink.querySelector("span").textContent = "";
    setColorProps(null, true);
  };

  const handleSecondaryMenuToggle = (e) => {
    let sMenuPrefix = e.target.textContent
      .trim()
      .toLowerCase()
      .replace(/[^\w\s]/gi, "")
      .replace(" ", "-");

    ttHeading.href = e.target.dataset.url;

    // * augment view all link
    viewLink.href = e.target.dataset.url;
    viewLink.querySelector("span").textContent = ` ${e.target.textContent}`;
    ttHeading.textContent = `${e.target.textContent}`;

    let submenus = document.querySelectorAll(`.${sMenuPrefix}-submenu`);
    submenus.forEach((submenu, i) => {
      submenu.classList.add("featured");
      if (submenu.classList.contains("title-hidden")) {
        ttIndicator.classList.add("hidden");
      } else {
        ttIndicator.classList.contains("hidden")
          ? ttIndicator.classList.remove("hidden")
          : null;
      }
    });
    switchPanels();
    setColorProps(sMenuPrefix, false);
  };

  const handlePrimaryMenuToggle = (e) => {
    const t = e.currentTarget ? e.currentTarget : e;
    if (t.querySelector("a")) return;
    let targetParent;
    let index;

    // * establish tier of 't'
    let isTierOne = t.parentElement.parentElement === panelOne ? true : false;

    // * get tier pointer
    let pointer = isTierOne
      ? panelOne.querySelector(".mobile-nav__panel-indicator")
      : panelTwo.querySelector(".mobile-nav__panel-indicator");

    let targetHeading = isTierOne
      ? null
      : panelTwo.querySelector(".tier-two-panel__current");

    if (t.parentElement.classList.contains("active")) {
      if (isTierOne) {
        return;
      }
      else {
        t.parentElement.classList.remove("active");
        pointer.classList.add("fade");
      }
      return;
    }


    // * get all max-depth ULs for established tier
    let firstTierSecondaryList = isTierOne
      ? document.querySelectorAll(".mobile-nav__secondary.first-tier-child")
      : document.querySelectorAll(".mobile-nav__secondary.second-tier-child");

    firstTierSecondaryList.forEach((listItem, listIndex) => {

      // * augment toggle classNames with 't' content
      let tierTwoToggles = listItem.querySelectorAll(".second-tier-toggle");
      let menuPrefix = t.textContent
        .toLowerCase()
        .trim()
        .replaceAll("'", "")
        .replaceAll(" ", "-");

      const parent = listItem.parentElement.parentElement;

      if (!listItem.classList.contains(`${menuPrefix}-menu`)) {
        // * clear out ACTIVE list items
        parent.classList.contains("active")
          ? parent.classList.remove("active")
          : null;
        // * remove event listeners from 'inactive' toggles inside listItem
        tierTwoToggles.forEach((toggle) => {
          toggle.removeEventListener("click", handleSecondaryMenuToggle);
        });
      } else {
        // INFO This is the active list!
        targetParent = parent;
        if (!isTierOne) {
          let featured = document.querySelectorAll(".featured");
          featured.forEach((featuredItem, i) => {
            if (featuredItem === parent) {
              index = i;

              return;
            }
          });
        } else {
          index = listIndex;
        }
        if (!isTierOne) {
          pointer.classList.add("fade");
          pointer.style.display = "block";
          setTimeout(() => {
            listItem.parentElement.parentElement.classList.add("active");
          }, 50);
        } else {
          listItem.parentElement.parentElement.classList.add("active");
        }
        tierTwoToggles.forEach((toggle) => {
          toggle.addEventListener("click", (e) => handleSecondaryMenuToggle(e));
        });
      }
    });

    setTimeout(
      () => {
        // * handle pointer movement

        // * get top of parent
        let pTop = targetParent.getBoundingClientRect().top;
        // * get top of current panel
        let panel = isTierOne ? panelOne : panelTwo;
        let panelTop = panel.getBoundingClientRect().top;
        // * if !isTierOne, account for extra distance from MENU heading
        const headingHeight = targetHeading ? getElemHeight(targetHeading) : 0;

        const translateAmount = pTop - panelTop - headingHeight;

        pointer.style.transform = `translateY(${
          translateAmount < 0 ? 2 : translateAmount
        }px`;
      },
      isTierOne ? 50 : 300
    );

    setTimeout(() => {
      pointer.classList.remove("fade");
    }, 350);
  };

  const getElemHeight = (elem) => {
    const h = elem.offsetHeight;
    const elemStyle = window.getComputedStyle(elem);

    let t = ["top", "bottom"]
      .map((styleKey) => parseInt(elemStyle[`margin-${styleKey}`], 10))
      .reduce((acc, val) => {
        return acc + val;
      }, 0);

    return h + t - 2;
  };

  menuBtn.addEventListener("click", menuOpen);
  document
    .querySelector(".mobile-nav__close")
    .addEventListener("click", menuClose);
  tierOneToggles.forEach((toggle) => {
    if (
      toggle.nextElementSibling &&
      toggle.nextElementSibling.firstElementChild.classList.contains("active")
    ) {
      handlePrimaryMenuToggle(toggle);
    }
    toggle.addEventListener("click", (e) => handlePrimaryMenuToggle(e));
  });

  window.addEventListener("resize", (e) => {
    let w = e.target.outerWidth;
    container.classList.contains("visible") && w >= 1025 ? menuClose() : null;
  });

  const setColorProps = (target, defaultColors) => {
    let viewLink = controls.querySelector(
      ".tier-two-panel__current-menu-collection"
    );
    let colorShiftStrokes = document.querySelectorAll(".color-switch");

    if (defaultColors) {
      container.style.backgroundColor = "";
      viewLink.removeAttribute("style");
      colorShiftStrokes.forEach((path) => path.removeAttribute("style"));
    } else {
      let activeEl = document.querySelectorAll(`.${target}-submenu`);
      activeEl.forEach((el) => el.removeAttribute("style"));

      let tx = [];
      let t = Object.keys(menuDataMob).map((key) => menuDataMob[key]);
      t.forEach((arr) => {
        tx.push(...arr);
      });

      let c = tx
        .filter((item) => item.title === target)
        .reduce(
          (acc, val) => ({ ...acc, background: val.bg, text: val.color }),
          {}
        );

      controls.style.color = c.text;
      container.style.backgroundColor = c.background;
      activeEl.forEach((el) => (el.style.color = c.text));
      viewLink.style.color = c.text;
      ttIndicator.style.fill = c.text;
      ttHeading.style.color = c.text;
      colorShiftStrokes.forEach((elem) => (elem.style.stroke = c.text));
    }
  };
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMobileMenu);
} else {
  initMobileMenu();
}
